import { Button } from '@components/button';
import { useContactUsModal } from '@components/modal';
import { Typography } from '@components/typography';
import { Box } from '@mui/material';
import posthog from 'posthog-js';
import { ExpiredModalWrapper } from './ExpiredModalWrapper';
import { ProgressCircle } from './ProgressCircle';

const calculateProgressBarPercentage = (day: number) => {
  switch (day) {
    case 1:
      return 90;
    case 2:
      return 75;
    case 3:
      return 60;
    case 4:
      return 45;
    case 5:
      return 30;
    case 6:
      return 15;
    case 7:
      return 0;
    default:
      return undefined;
  }
};

type ExpirationModalProps = {
  days: number;
  organizationId: string;
  name?: string;
  onClose: () => void;
};

export const ExpiringSoonModal = ({
  days,
  organizationId,
  name,
  onClose,
}: ExpirationModalProps) => {
  const { showModal: openContactUsModal } = useContactUsModal({
    componentProps: {
      defaultSubject: `Plan information for ${name} (${organizationId})`,
    },
  });

  const handleContactUsButton = () => {
    posthog.capture('user_contact-us_intent', {
      location: 'organizations-plan-information',
    });
    openContactUsModal();
  };

  return (
    <ExpiredModalWrapper onClickAway={onClose}>
      <Box display="flex" justifyContent="center">
        <Typography variant="subtitle1">Your subscription is expiring soon!</Typography>
      </Box>
      <ProgressCircle
        content={`${days || 1} ${days > 1 ? 'days' : 'day'}`}
        warning
        value={calculateProgressBarPercentage(days)}
      />
      <Typography variant="body2" textAlign="center">
        Your subscription expires in {days || 1} {days > 1 ? 'days' : 'day'}.
      </Typography>
      <Button fullWidth onClick={handleContactUsButton}>
        Contact us
      </Button>
      <Button variant="secondary" fullWidth onClick={onClose}>
        Continue
      </Button>
    </ExpiredModalWrapper>
  );
};
